import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "shared/components/FormElements/Button";
import Modal from "shared/components/UIElements/Modal";

import "./DeleteModal.css";

const formatTextWithLineBreaks = (text) => {
  if (!text) return "";
  const lines = text.split("\n");
  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 && <br />}
    </React.Fragment>
  ));
};

const MessageModal = ({ showModal, title, text, onClose }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(showModal);

  useEffect(() => {
    setShow(showModal);
  }, [showModal]);

  const closeHandler = () => {
    setShow(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      show={show}
      onCancel={closeHandler}
      header={title}
      footerClass="delete-modal-footer"
      footer={
        <div className="delete-modal-buttons-container">
          <Button onClick={closeHandler}>{t("close")}</Button>
        </div>
      }
    >
      <p>{formatTextWithLineBreaks(text)}</p>
    </Modal>
  );
};

export default MessageModal;
